<template>
    <b-overlay :show="loading" opacity="1" rounded :class="loading ? 'p-3' : null">
        <div class="row">
            <div class="mb-50 order-0" :class="result ? 'col-lg-6' : 'col-12'">
                <table class="table table-sm table-bordered mb-0 ">
                    <thead>
                        <tr>
                            <th class="w-50">KYKM</th>
                            <th class="w-50">Değer (Gün)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="kykm in types" :key="kykm.Id">
                            <td class="font-weight-bolder bg-light">
                                {{ kykm.Name }}
                            </td>
                            <td class="p-25">
                                <input type="number" class="form-control form-control-sm" v-model="kykm.Value"/>    
                            </td>  
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-lg-6 mt-50 mt-lg-0 order-2 order-lg-1" v-if="result">
                <table class="table table-sm table-bordered mb-0">
                    <thead>
                        <tr>
                            <th class="w-50">KYKM</th>
                            <th class="w-50">Ücret</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(r,index) in result" :key="r.Name + index">
                            <td class="font-weight-bolder bg-light">{{r.Name}}</td>
                            <td class="text-right">{{r.Price == 0 ? Number(r.Price).toFixed(2) : r.Price}}TL</td>
                        </tr>
                        <tr>
                            <td class="font-weight-bolder bg-light-primary">Toplam</td>
                            <td class="font-weight-bolder bg-light-primary text-right">{{total}}TL</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-12 order-1 order-lg-2">
                <v-executer full-width text="Hesapla" :loading="calculating" :action="calc"></v-executer>
            </div>
        </div>
    </b-overlay>
</template>

<script>
import { BOverlay } from 'bootstrap-vue'
import HumanResourcesParameterApi from '@/api/human-resources-parameters'
import EmployeeOperationsApi from '@/api/employee-operations'

export default {
    props:{
        id:[Number,String]
    },
    components:{
        BOverlay
    },
    data(){
        return {
            types:[],
            loading:true,
            calculating:false,
            result:null
        }
    },
    mounted(){
        this.getTypes()
    },
    methods:{
        getTypes(){
            this.loading = true
            HumanResourcesParameterApi.SalaryEffect.Type.List().then(res=>{
                if(res.data.Success){
                    this.loading = false
                    this.types = res.data.Data?.map(d=>({...d,Value:0}))
                }
            })
        },
        calc(){
            let data = {
                EmployeeId:this.id,
                KYKMs:this.types?.map(t=>({
                    SystemCode:t.SystemCode,
                    Days:Number(t.Value) || 0,
                    Multiple:t.Multiple
                }))
            }
            this.calculating = true
            this.result = null
            EmployeeOperationsApi.Score.TestPuantaj(data).then(res=>{
                this.calculating = false
                if(res.data.Success){
                    this.result = res.data.Data
                }else{
                    this.$result(res)
                }
            }).catch(err=>{
                this.calculating = false
                this.$result(null,err)
            })
            
        }
    },
    computed:{
        total(){
            return this.result?.reduce((s,t)=>{
                s += parseFloat(t.Price) || 0
                return s
            },0)?.toFixed(2) || Number(0).toFixed(2)
        }
    }
}
</script>

<style>
.dark-layout .bg-light-primary{
    color: white !important;
}
</style>